<template>
    <div>
      <div class="modal fade" id="changePasswordJm" tabindex="-1" aria-labelledby="loginLabel" aria-hidden="true" data-bs-backdrop="false" style="background-color:rgba(0, 0, 0, 0.5);">
          <div class="modal-dialog modal-sm modal-dialog-centered">
              <div class="modal-content" style="background-color: rgba(60,60,60,.95);">
                  <div class="modal-header2 p-0" style="">
                      <h6 class="modal-title" id="exampleModalLabel">{{ translate('change_password') }}
                          <button id="closeChangePassword" :style="skin.my_account.close_btn" style="background:transparent;float: right;color:white" type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"><i class="fas fa-times"></i></button>
                      </h6>
                  </div>
                  <div class="modal-body p-4" style="height:30%">
                      <div class="text-center">
                            <span v-if="showChangePassword">{{ translate('sugerencia') }}</span>
                          <form @submit.prevent="changePassword()">
                              <div class="pb-2 font-size-custom mb-3 my-3">
                                <i class="fas fa-eye prefix change-password-reveal lightgrey-text mx-2" @click="show_hide_Password('passwordJm')"></i>
                                  <input v-model="password" id="passwordJm" type="password" :placeholder="translate('new_password')" class="login-user-control" autocomplete="off" required>
                              </div>
                              <div class="pb-2 font-size-custom mb-3 my-3">
                                <i class="fas fa-eye prefix change-password-reveal lightgrey-text mx-2" @click="show_hide_Password('passwordJm2')"></i>
                                  <input v-model="password2" id="passwordJm2" type="password" :placeholder="translate('repeat_password')" class="login-user-control" maxlength="16" autocomplete="off" required>
                              </div>
                              <br>
                              <div class="d-flex my-3">
                                  <button class="btn p-2 mx-2" type="button" style="text-transform: uppercase; background-color: #292d3d!important;color:white;width:50%" data-bs-dismiss="modal" aria-label="Close">{{ translate('close') }}</button>
                                  <button id="submit_btn2" type="submit" class="btn p-2 mx-2" style="background-color: #292d3d!important;color:white;width:50%" :disabled="login_inProcess">{{ translate('actual') }}</button>
                              </div>
                          </form>
                          <div v-if="status.message!=''" :class="'alert alert-'+status.type" role="alert">{{ status.message }}</div>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    </div>
  </template>
  
  <script>
  import axios from 'axios';
  export default {
      name:"changePassword",
      props:['skin','translation','language'],
      data(){
          return {
              password:"",
              password2:"",
              show1:true,
              show2:true,
              status:{
                  message:"",
                  type:""
              },
              login_inProcess:false
          }
      },
      computed:{
        user() {
            let data = this.$store.getters['getUserData'];
            return data;
        },
        showChangePassword(){
            return this.$store.getters['getShowChangePassword'];
        },
        apiUrlnew(){
            return this.$store.getters['getApiUrlnew'];
        },
        site(){
            return this.$store.getters['getSite'];
        },
      },
      methods:{
          async changePassword(){
                try {
                    this.login_inProcess = true;
                    let data = await axios.post(this.apiUrlnew +"cambiar_password", 
                    {
                        "users": [this.user.user_data.data.user_id ?? this.user.user_data.data.id],
                        "password": this.password,
                        "password1": this.password2,
                        "token":this.user.token,
                        "login_id":this.user.user_data.data.user_id ?? this.user.user_data.data.id,
                        "site": this.site

                    })
                    if(data.data.error){
                        this.status.message = data.data.error;
                        this.status.type = "danger";
                    }
                    else{
                        this.status.message = data.data.message;
                        this.status.type = "success";
                        this.logout();
                        setTimeout(()=>{
                            document.getElementById("closeChangePassword").click();
                        },2000)
                    }
                    this.login_inProcess = false;
                } catch (error) {
                    this.status.message = error.response.data.error;
                    this.status.type = "danger";
                    this.login_inProcess = false;
                }
                
          },
        logout(){
            this.$store.dispatch('logOut');
            this.$root.$emit('forceRender');
        },
          translate(text) {
              if(text){
                  if (this.$props.translation[text]) {
                      return this.$props.translation[text][this.$props.language];
                  }
                  else{
                      var new_text_serched = text.replace(/ /g, "_");
                      if (this.$props.translation[new_text_serched]) {
                          return this.$props.translation[new_text_serched][this.$props.language];
                      }
                  }
                  return text;
              }
          },
          show_hide_Password(target){
            if(target == "password"){
                document.getElementById(target).type = this.show1?"text":"password";
                this.show1 = !this.show1;
            }
            else{
                document.getElementById(target).type = this.show2?"text":"password";
                this.show2 = !this.show2;
            }
          },
      }
  }
  </script>
  
  <style scoped>
  .modal-header2 {
      margin-left: 5%!important;
      margin-right: 5%!important;
      margin-top: -1.25rem!important;
      margin-bottom: 0!important;
      height: 60px;
      padding: 1rem!important;
      color: #fff;
      border-bottom: none;
      background:linear-gradient(40deg,#292d3d,#03040d)!important
  }
  .close2 {
      float: right;
      font-size: 1.5rem;
      font-weight: 700;
      line-height: 1;
      color: #000;
      text-shadow: 0 1px 0 #fff;
      opacity: .5;
  }
  .login-user-control{
      color: #fff;
      margin-left: 2.5rem;
      width: calc(100% - 2.5rem);
      -webkit-transition: border-color .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;
      -o-transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
      transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
      transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out,-webkit-box-shadow .15s ease-in-out;
      outline: 0;
      -webkit-box-shadow: none;
      box-shadow: none;
      border: none;
      border-bottom: 1px solid #ced4da;
      -webkit-border-radius: 0;
      border-radius: 0;
      -webkit-box-sizing: content-box;
      box-sizing: content-box;
      background-color: transparent;
      margin: 0 0 0.5rem;
      -webkit-border-radius: 0;
      border-radius: 0;
      padding: 0.3rem 0 0.55rem;
      background-image: none;
      background-color: transparent;
      height: auto;
  }
  </style>